export enum JustifyContents {
    flexStart = 'flex-start',
    flexEnd = 'flex-end',
    center = 'center',
    spaceBetween = 'space-between',
    spaceAround = 'space-around',
    spaceEvenly = 'space-evenly',
}
